// import React, { useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import Breadcrumbs from "../components/Breadcrumbs";
// import useChatRoom, { parseRoomId } from "../hooks/useChatRoom";
// import "../assets/css/chat.scss";

// const ChatRoom = () => {
//   const { roomId: roomFromParams } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const sessionUserId = sessionStorage.getItem("id");
//   const state = location.state || {};

//   const derived = useMemo(() => {
//     const parsed = parseRoomId(roomFromParams);
//     return {
//       productId: state.productId || parsed.productId,
//       buyerId: state.buyerId || parsed.buyerId || sessionUserId,
//       sellerId: state.sellerId || parsed.sellerId || sessionUserId,
//       productName: state.productName || "Product",
//       buyerName: state.buyerName || (parsed.buyerId ? `Buyer #${parsed.buyerId}` : "Buyer"),
//     };
//   }, [roomFromParams, state, sessionUserId]);

//   const [draft, setDraft] = useState("");
//   const {
//     roomId,
//     messages,
//     status,
//     error,
//     hasMore,
//     partnerTyping,
//     sendMessage,
//     fetchMoreHistory,
//     startTyping,
//     stopTyping,
//   } = useChatRoom({
//     productId: derived.productId,
//     buyerId: derived.buyerId,
//     sellerId: derived.sellerId,
//     roomId: roomFromParams,
//     currentUserId: sessionUserId,
//   });

//   const displayMessages = useMemo(() => {
//     const seen = new Map();
//     messages.forEach((msg) => {
//       const key =
//         msg.id ||
//         [
//           msg.roomId || "room",
//           msg.senderId || "sender",
//           msg.message || "",
//           msg.createdAt || "timestamp",
//         ].join("-");
//       if (!seen.has(key)) {
//         seen.set(key, msg);
//         return;
//       }
//       const existing = seen.get(key);
//       if (existing?.pending && !msg.pending) {
//         seen.set(key, msg);
//       }
//     });
//     return Array.from(seen.values());
//   }, [messages]);

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (!draft.trim()) return;
//     sendMessage(draft);
//     setDraft("");
//     stopTyping();
//   };

//   const handleDraftChange = (event) => {
//     setDraft(event.target.value);
    
//     startTyping();
//   };

//   const resolveTimestamp = (msg) =>
//     msg.createdAt ||
//     msg.sendMessageAt ||
//     msg.updatedAt ||
//     msg.lastMessageAt ||
//     msg.send_message_at ||
//     msg.timestamp ||
//     null;

//   const formatTime = (timestamp) => {
//     if (!timestamp) return "";
//     return new Date(timestamp).toLocaleTimeString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const handleBack = () => navigate(-1);

//   return (
//     <div className="chat-layout">
//       <Breadcrumbs
//         title="Chat"
//         items={[
//           { label: "Dashboard", path: "/" },
//           { label: derived.productName, path: "#" },
//         ]}
//       />

//       <div className="chat-card">
//         <header className="d-flex justify-content-between align-items-center mb-3">
//           <div>
//             <h2 className="mb-0">{derived.productName}</h2>
//             <small className="text-muted">
//               Room: {roomId || "initializing"} · {status}
//             </small>
//           </div>
//           <button className="btn btn-outline-secondary" onClick={handleBack}>
//             Back
//           </button>
//         </header>

//         {error && (
//           <div className="alert alert-danger">
//             Something went wrong loading this conversation. Please try again.
//           </div>
//         )}

//         <div className="chat-room">
//           <div className="chat-room__messages">
//             {hasMore && (
//               <button className="chat-room__history-btn" onClick={fetchMoreHistory}>
//                 Load previous messages
//               </button>
//             )}
//             {displayMessages.map((msg) => {
//               const outgoing = msg.senderId?.toString() === sessionUserId?.toString();
//               return (
//                 <div
//                   key={msg.id}
//                   className={`chat-message ${
//                     outgoing ? "chat-message--outgoing" : "chat-message--incoming"
//                   }`}
//                 >
//                   <span>{msg.message}</span>
//                   <span className="chat-message__time">
//                     {msg.pending ? "Sending…" : formatTime(resolveTimestamp(msg))}
//                   </span>
//                 </div>
//               );
//             })}
//             {partnerTyping && <div className="chat-room__typing">Typing…</div>}
//           </div>

//           <form className="chat-composer" onSubmit={handleSubmit}>
//             <textarea
//               value={draft}
//               onChange={handleDraftChange}
//               placeholder="Type your message…"
//               onBlur={stopTyping}
//             />
//             <button type="submit" disabled={!draft.trim()}>
//               Send
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ChatRoom;


import React, { useMemo, useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";
import useChatRoom, { parseRoomId } from "../hooks/useChatRoom";
import { editMessage, unsendMessage, deleteMessageForMe, deleteAllMessagesForMe } from "../services/chatService";
import "../assets/css/chat.scss";
import { FiEdit2, FiRotateCw, FiTrash2 } from "react-icons/fi"; 

// Message Menu Component
const MessageMenu = ({ message, sessionUserId, onEdit, onDelete, onUnsend, onClose }) => {
  const menuRef = useRef(null);
  const isOutgoing = message.senderId?.toString() === sessionUserId?.toString();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  if (!isOutgoing || message.pending) return null;

  return (
    <div ref={menuRef} className="message-menu">
  <button onClick={() => onEdit(message)} className="message-menu__item">
    <FiEdit2 className="message-menu__icon" />
    Edit
  </button>

  <button onClick={() => onUnsend(message)} className="message-menu__item">
    <FiRotateCw className="message-menu__icon" />
    Unsend
  </button>

  <button
    onClick={() => onDelete(message)}
    className="message-menu__item message-menu__item--danger"
  >
    <FiTrash2 className="message-menu__icon" />
    Delete for me
  </button>
</div>
  );
};

// Edit Modal Component
const EditMessageModal = ({ message, onSave, onCancel }) => {
  const [editedText, setEditedText] = useState(message.message);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    if (editedText.trim() && editedText !== message.message) {
      setIsSaving(true);
      await onSave(editedText.trim());
      setIsSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Edit Message</h3>
        <textarea
          value={editedText}
          onChange={(e) => setEditedText(e.target.value)}
          autoFocus
          rows={4}
          className="edit-textarea"
        />
        <div className="modal-actions">
          <button type="button" onClick={onCancel} className="btn-cancel" disabled={isSaving}>
            Cancel
          </button>
          <button 
            type="button"
            onClick={handleSubmit}
            disabled={!editedText.trim() || editedText === message.message || isSaving}
            className="btn-save"
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

// Confirmation Modal Component
const ConfirmModal = ({ title, message, onConfirm, onCancel, confirmText = "Confirm", isLoading }) => {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content modal-content--small" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="modal-actions">
          <button onClick={onCancel} className="btn-cancel" disabled={isLoading}>
            Cancel
          </button>
          <button onClick={onConfirm} className="btn-confirm" disabled={isLoading}>
            {isLoading ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

const ChatRoom = () => {
  const { roomId: roomFromParams } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const sessionUserId = sessionStorage.getItem("id");
  const state = location.state || {};

  const derived = useMemo(() => {
    const parsed = parseRoomId(roomFromParams);
    return {
      productId: state.productId || parsed.productId,
      buyerId: state.buyerId || parsed.buyerId || sessionUserId,
      sellerId: state.sellerId || parsed.sellerId || sessionUserId,
      productName: state.productName || "Product",
      buyerName: state.buyerName || (parsed.buyerId ? `Buyer #${parsed.buyerId}` : "Buyer"),
    };
  }, [roomFromParams, state, sessionUserId]);

  const [draft, setDraft] = useState("");
  const [activeMenu, setActiveMenu] = useState(null);
  const [editingMessage, setEditingMessage] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null);
  const [isActionLoading, setIsActionLoading] = useState(false);

  const {
    roomId,
    messages,
    status,
    error,
    hasMore,
    partnerTyping,
    sendMessage,
    fetchMoreHistory,
    startTyping,
    stopTyping,
    updateMessageLocally,
    removeMessageLocally,
    clearAllMessages,
  } = useChatRoom({
    productId: derived.productId,
    buyerId: derived.buyerId,
    sellerId: derived.sellerId,
    roomId: roomFromParams,
    currentUserId: sessionUserId,
  });

  const displayMessages = useMemo(() => {
    const seen = new Map();
    messages.forEach((msg) => {
      const key =
        msg.id ||
        [
          msg.roomId || "room",
          msg.senderId || "sender",
          msg.message || "",
          msg.createdAt || "timestamp",
        ].join("-");
      if (!seen.has(key)) {
        seen.set(key, msg);
        return;
      }
      const existing = seen.get(key);
      if (existing?.pending && !msg.pending) {
        seen.set(key, msg);
      }
    });
    return Array.from(seen.values());
  }, [messages]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!draft.trim()) return;
    sendMessage(draft);
    setDraft("");
    stopTyping();
  };

  const handleDraftChange = (event) => {
    setDraft(event.target.value);
    startTyping();
  };

  const handleEdit = (message) => {
    setActiveMenu(null);
    setEditingMessage(message);
  };

  const handleSaveEdit = async (newText) => {
    try {
      await editMessage(roomId, editingMessage.id, { message: newText });
      updateMessageLocally(editingMessage.id, { message: newText, edited: true });
      setEditingMessage(null);
    } catch (err) {
      console.error("Edit error:", err);
      alert("Failed to edit message. Please try again.");
    }
  };

  const handleUnsend = (message) => {
    setActiveMenu(null);
    setConfirmAction({
      type: 'unsend',
      message,
      title: 'Unsend Message',
      text: 'This message will be removed for everyone. This action cannot be undone.'
    });
  };

  const handleDelete = (message) => {
    setActiveMenu(null);
    setConfirmAction({
      type: 'delete',
      message,
      title: 'Delete Message',
      text: 'This message will be deleted for you only.'
    });
  };

  const handleDeleteAllConversation = () => {
    if (!roomId) return;
    setConfirmAction({
      type: 'deleteAll',
      title: 'Delete conversation',
      text: 'All messages in this conversation will be removed for you.',
    });
  };

  const executeAction = async () => {
    if (!confirmAction) return;

    const { type, message } = confirmAction;
    setIsActionLoading(true);

    try {
      if (type === 'unsend') {
        await unsendMessage(roomId, message.id);
      } else if (type === 'delete') {
        await deleteMessageForMe(roomId, message.id);
      } else if (type === 'deleteAll') {
        await deleteAllMessagesForMe(roomId);
        clearAllMessages();
      }
      
      if (message?.id) {
        removeMessageLocally(message.id);
      }
      setConfirmAction(null);
    } catch (err) {
      console.error(`${type} error:`, err);
      alert(`Failed to ${type} message. Please try again.`);
    } finally {
      setIsActionLoading(false);
    }
  };

  const resolveTimestamp = (msg) =>
    msg.createdAt ||
    msg.sendMessageAt ||
    msg.updatedAt ||
    msg.lastMessageAt ||
    msg.send_message_at ||
    msg.timestamp ||
    null;

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    return new Date(timestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleBack = () => navigate(-1);

  return (
    <div className="chat-layout">
      <Breadcrumbs
        title="Chat"
        items={[
          { label: "Dashboard", path: "/" },
          { label: derived.productName, path: "#" },
        ]}
      />

      <div className="chat-card">
        <header className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h2 className="mb-0">{derived.productName}</h2>
            <small className="text-muted">
              Room: {roomId || "initializing"} · {status}
            </small>
          </div>
          <div className="chat-header__actions">
            <button
              className="btn btn-outline-danger me-2 chat-delete-all-btn"
              type="button"
              onClick={handleDeleteAllConversation}
              disabled={!messages.length || isActionLoading}
            >
              <FiTrash2 className="me-1" />
              Delete conversation
            </button>
            <button className="btn btn-outline-secondary" onClick={handleBack}>
              Back
            </button>
          </div>
        </header>

        {error && (
          <div className="alert alert-danger">
            Something went wrong loading this conversation. Please try again.
          </div>
        )}

        <div className="chat-room">
          <div className="chat-room__messages">
            {hasMore && (
              <button className="chat-room__history-btn" onClick={fetchMoreHistory}>
                Load previous messages
              </button>
            )}
            {displayMessages.map((msg) => {
              const outgoing = msg.senderId?.toString() === sessionUserId?.toString();
              return (
                <div
                  key={msg.id}
                  className={`chat-message ${
                    outgoing ? "chat-message--outgoing" : "chat-message--incoming"
                  }`}
                >
                  <div className="chat-message__content">
                    <span>{msg.message}</span>
                    {msg.edited && (
                      <span className="chat-message__edited">(edited)</span>
                    )}
                    {outgoing && !msg.pending && (
                      <button
                        className="chat-message__menu-btn"
                        onClick={() => setActiveMenu(activeMenu === msg.id ? null : msg.id)}
                      >
                        ⋮
                      </button>
                    )}
                  </div>
                  <span className="chat-message__time">
                    {msg.pending ? "Sending…" : formatTime(resolveTimestamp(msg))}
                  </span>
                  {activeMenu === msg.id && (
                    <MessageMenu
                      message={msg}
                      sessionUserId={sessionUserId}
                      onEdit={handleEdit}
                      onDelete={handleDelete}
                      onUnsend={handleUnsend}
                      onClose={() => setActiveMenu(null)}
                    />
                  )}
                </div>
              );
            })}
            {partnerTyping && <div className="chat-room__typing">Typing…</div>}
          </div>

          <form className="chat-composer" onSubmit={handleSubmit}>
            <textarea
              value={draft}
              onChange={handleDraftChange}
              placeholder="Type your message…"
              onBlur={stopTyping}
            />
            <button type="submit" disabled={!draft.trim()}>
              Send
            </button>
          </form>
        </div>
      </div>

      {editingMessage && (
        <EditMessageModal
          message={editingMessage}
          onSave={handleSaveEdit}
          onCancel={() => setEditingMessage(null)}
        />
      )}

      {confirmAction && (
        <ConfirmModal
          title={confirmAction.title}
          message={confirmAction.text}
          onConfirm={executeAction}
          onCancel={() => setConfirmAction(null)}
          confirmText={
            confirmAction.type === 'deleteAll'
              ? 'Delete all'
              : confirmAction.type === 'unsend'
              ? 'Unsend'
              : 'Delete'
          }
          isLoading={isActionLoading}
        />
      )}
    </div>
  );
};

export default ChatRoom;
